import { 
  UPDATE_CLOSE_REASON_REQUEST, 
  UPDATE_CLOSE_REASON_SUCCESS, 
  UPDATE_CLOSE_REASON_FAILURE 
} from "../../../components/CloseReasonDropdown/CloseReasonDropdown.actions";

export function Reducer(previousState, action) {
  let newState = Object.assign({}, previousState);

  switch (action.type) {
    case "UPDATE_HSC_SWITCH_LIST_SUCCESS":
      newState = Object.assign({}, previousState, {
        data: action.payload.records,
        pages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
        loading: false,
        isError: false,
      });
      newState.listState.page = action.payload.page;
      break;
    case "UPDATE_HSC_SWITCH_LIST_REQUEST":
      newState = Object.assign({}, previousState, {
        listState: action.payload.listState,
        totalElements: "Loading ...",
        loading: true,
        isError: false,
      });
      break;
    case "UPDATE_HSC_SWITCH_INDEX_ON_LIST":
      newState = Object.assign({}, previousState, {
        indexOnList: action.indexOnList,
      });
      break;
    case "UPDATE_HSC_SWITCH_LIST_FAILURE":
      newState = Object.assign({}, previousState, {
        data: [],
        pages: 0,
        totalElements: 0,
        loading: false,
        isError: true,
      });

      break;
    case "RESET_ERROR_MESSAGE_HSC_SWITCH_LIST":
      newState = Object.assign({}, previousState, {
        isError: false,
      });
      break;
    case UPDATE_CLOSE_REASON_SUCCESS:
      const { globalSwitchId, closeReason, latestProcessedDate } = action.payload;
      const data = newState.data.map(item => {
        if (item.globalSwitchId === globalSwitchId) {
          return { ...item, closeReason, processedDate: latestProcessedDate };
        }
        return item;
      });
      newState = Object.assign({}, previousState, { data });
      break;
    default:
      break;
  }

  return newState;
}
